import { render, staticRenderFns } from "./identity.vue?vue&type=template&id=6aaf519a&scoped=true"
import script from "./identity.vue?vue&type=script&lang=js"
export * from "./identity.vue?vue&type=script&lang=js"
import style0 from "./identity.vue?vue&type=style&index=0&id=6aaf519a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaf519a",
  null
  
)

export default component.exports